import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const firstRun = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Base GA/Meta Pixel already fire one PageView on initial load, so only
    // track subsequent client-side route changes here to avoid double counting.
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    const path = pathname + search;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', { page_path: path, page_location: window.location.href });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
